// extracted by mini-css-extract-plugin
export default {"ScreenXXSMin":"(min-width: 544px)","CardBreakpoint":"(min-width: 544px)","cardsContainer":"G28fadf","loading":"G0a9a1f"};